import { NgModule } from '@angular/core';
import { XpoBadgeDirective } from './xpo-badge.directive';
const directives = [XpoBadgeDirective];

@NgModule({
  declarations: directives,
  exports: directives,
})
export class DirectivesModule {}
